import axios from 'axios';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import qs from 'query-string';
import qsFilters from 'qs';

// Libs
import { thunkHandler, thunkErrorHanlder, parseUrl, Consequence } from '../../libs/utils';

// Constants
import {
  CONTRACT_BASE,
  CONTRACT_DETAIL,
  CONTRACT_EXPORT,
  CREATE_CONTRACT,
  PORTAL_CONTRACT,
  CLIENT_RECURRING_PAYMENT,
  CLIENT_CONFIRM_DOMICILIATION,
  CONTRACT_RECURRING_PAYMENT,
  CLIENT_RECURRING_PAYMENT_QUERY,
  CONTRACT_IMPORT,
  CLIENT_CONTRACTS,
  CONTRACT_FRECUENCY,
  CANCEL_CONTRACT,
  CLIENT_UPDATE_RECURRING_PAYMENT_QUERY,
  CONTRACT_UPDATE,
  EARLY_PAYMENT,
  EARLY_PAYMENT_BASE,
  EARLY_PAYMENT_BYID,
  EARLY_PAYMENT_CONTRACT
} from '../../constants/endpoints';

export const NEW_CONTRACTS = 'NEW_CONTRACTS';
export const NEW_SINGLE_CONTRACT = 'NEW_SINGLE_CONTRACT';
export const NEW_EXPORT_CONTRACTS = 'NEW_EXPORT_CONTRACTS';
export const NEW_SINGLE_CONTRACT_PORTAL = 'NEW_SINGLE_CONTRACT_PORTAL';
export const NEW_RECURRING_PAYMENT = 'NEW_RECURRING_PAYMENT';
export const NEW_STRIPE_SESSION_ID = 'NEW_STRIPE_SESSION_ID';
export const NEW_IMPORT_CONTRACTS = 'NEW_IMPORT_CONTRACTS';
export const NEW_CONTRACTS_FILTERS = 'NEW_CONTRACTS_FILTERS';
export const NEW_VALUES_CONTRACTS = 'NEW_VALUES_CONTRACTS';
export const NEW_LOADING_TABLE = 'NEW_LOADING_TABLE';
export const NEW_SEARCHING = 'NEW_SEARCHING';
export const NEW_STATS_CONTRACTS = 'NEW_STATS_CONTRACTS';
export const CHANGE_CONTRACT_SELECT = 'CHANGE_CONTRACT_SELECT';
export const SET_CONTRACT_TO_EDIT = 'SET_CONTRACT_TO_EDIT';
export const EARLY_CATALOG = 'EARLY_CATALOG';
export const NEW_EARLY_PAYMENT = 'NEW_EARLY_PAYMENT';
export const UPDATE_EARLY_PAYMENT = 'UPDATE_EARLY_PAYMENT';
export const DELETE_EARLY_PAYMENT = 'DELETE_EARLY_PAYMENT';
export const EARLY_BYID = 'EARLY_BYID';
export const EARLY_CONTRACT = 'EARLY_CONTRACT';
export const EARLY_ALL = 'EARLY_ALL';
export const RESET_EARLY_BYID = 'RESET_EARLY_BYID';
function filterCatalog(n) {
  switch (parseInt(n)) {
    case 1:
      return `active`;

    case 2:
      return `inactive`;

    case 3:
      return `no_ended`;
  } // END switch

  return null;
} // END filterCatalog

export function getContracts(params) {
  if (typeof params !== 'object') params = {};
  const qsObj = {};
  const { activeTab, page, identifier, customer, sort, startDate, endDate, cancelToken } = params;

  if (activeTab) qsObj.filter = filterCatalog(activeTab);
  if (page) qsObj.page = page;
  if (identifier) qsObj.identifier = identifier;
  if (customer) qsObj.customer = customer;
  if (sort) qsObj.sort = sort;
  if (startDate) {
    qsObj.start = startDate;
    if (endDate) qsObj.end = endDate;
    else qsObj.end = moment().format('YYYY-MM-DD');
  } // END if

  return dispatch =>
    axios
      .get(`${CONTRACT_BASE}?${qs.stringify(qsObj)}`, cancelToken ? { cancelToken: cancelToken.token } : {})
      .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_CONTRACTS, 'ERROR', res))
      .then(res => thunkHandler(dispatch, get(res, 'data.filters_stats', []), NEW_STATS_CONTRACTS, 'ERROR', res))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END getInvoices

export function getContractsPortal(uuid, params) {
  if (typeof params !== 'object') params = {};
  const qsObj = {};
  const { page, identifier } = params;

  if (page) qsObj.page = page;
  if (identifier) qsObj.identifier = identifier;

  return dispatch =>
    axios
      .get(parseUrl(`${CLIENT_CONTRACTS}?${qs.stringify(qsObj)}`, { uuid }))
      .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_CONTRACTS, 'ERROR', res))
      .then(res => thunkHandler(dispatch, get(res, 'data.filters_stats', []), NEW_STATS_CONTRACTS, 'ERROR', res))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END getInvoices

export function exportContracts(params = {}) {
  if (typeof params !== 'object') params = {};
  const qsObj = {};
  const { activeTab, page, identifier, customer, startDate, endDate } = params;

  if (activeTab) qsObj.filter = filterCatalog(params.activeTab);
  if (page) qsObj.page = params.page;
  if (identifier) qsObj.identifier = params.search;
  if (customer) qsObj.customer = customer;
  if (startDate) {
    qsObj.start = startDate;
    if (endDate) qsObj.end = endDate;
    else qsObj.end = moment().format('YYYY-MM-DD');
  } // END if

  return dispatch =>
    axios
      .get(`${CONTRACT_EXPORT}?${qs.stringify(qsObj)}`, { responseType: 'arraybuffer' })
      .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_EXPORT_CONTRACTS, 'ERROR', res))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END exportInvoices

export function getSingleContract(uuid) {
  return dispatch =>
    axios
      .get(parseUrl(CONTRACT_DETAIL, { uuid }))
      .then(res => thunkHandler(dispatch, get(res, 'data.data', {}), NEW_SINGLE_CONTRACT, 'ERROR'));
  // .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END getSingleInvoice

export function getPortalContract(uuid, id, page = 1) {
  return dispatch =>
    axios.get(parseUrl(PORTAL_CONTRACT, { uuid, id }, { page })).then(
      res =>
        new Consequence({
          dispatch,
          payload: { data: {...get(res, 'data.data', {}), pagination: get(res, 'data.pagination', {})} },
          eventTypes: { success: NEW_SINGLE_CONTRACT_PORTAL, error: 'ERROR' }
        })
    );
} // END getPortalContract

export function createContract(payload) {
  return dispatch =>
    axios.post(CREATE_CONTRACT, payload).then(
      res =>
        new Consequence({
          dispatch,
          payload: { data: get(res, 'data.data', {}) },
          eventTypes: { success: NEW_SINGLE_CONTRACT, error: 'ERROR' }
        })
    );
} // END createContract

/**
 * Cancela contrato y actualiza estado de redux de detalle del contrato
 * @param {Object} contract
 * @return
 */
export function cancelContract(contract = {}) {
  const { uuid } = contract;

  return dispatch =>
    axios.put(parseUrl(CANCEL_CONTRACT, { uuid })).then(() => {
      const newContract = {
        ...contract,
        status: 'canceled'
      };

      return new Consequence({
        dispatch,
        payload: { data: newContract },
        eventTypes: { success: NEW_SINGLE_CONTRACT, error: 'ERROR' }
      });
    });
}

export function requestRecurringPaymentAdmin(payload) {
  return dispatch =>
    axios.post(CONTRACT_RECURRING_PAYMENT, payload).then(
      res =>
        new Consequence({
          dispatch,
          payload: { data: res },
          eventTypes: { success: NEW_RECURRING_PAYMENT, error: 'ERROR' }
        })
    );
} // END CLIENT_RECURRING_PAYMENT

export function requestRecurringPaymentClient(uuid, payload) {
  return dispatch =>
    axios.post(parseUrl(CLIENT_RECURRING_PAYMENT, { uuid }), payload).then(
      res =>
        new Consequence({
          dispatch,
          payload: { data: res },
          eventTypes: { success: NEW_RECURRING_PAYMENT, error: 'ERROR' }
        })
    );
} // END CLIENT_RECURRING_PAYMENT

export function createStripeSessionRecurringPayment(uuid, payload) {
  return dispatch =>
    axios.post(parseUrl(CLIENT_CONFIRM_DOMICILIATION, { uuid }), payload).then(
      res =>
        new Consequence({
          dispatch,
          payload: { data: get(res, 'data.data') },
          eventTypes: { success: NEW_STRIPE_SESSION_ID, error: 'ERROR' }
        })
    );
} // END CLIENT_RECURRING_PAYMENT

export function updateRecurringPaymentFiservIntegration(payload) {
  return dispatch =>
    axios.put(CLIENT_UPDATE_RECURRING_PAYMENT_QUERY, payload).then(res => {
      return new Consequence({
        dispatch,
        payload: { data: get(res, 'data.data') },
        eventTypes: { success: NEW_STRIPE_SESSION_ID, error: 'ERROR' }
      });
    });
}

export function deleteRecurringPaymentContract(uuid, c) {
  return dispatch =>
    axios.delete(parseUrl(CLIENT_RECURRING_PAYMENT_QUERY, { uuid }, { c })).then(
      res =>
        new Consequence({
          dispatch,
          payload: { data: res },
          eventTypes: { success: NEW_RECURRING_PAYMENT, error: 'ERROR' }
        })
    );
} // END CLIENT_RECURRING_PAYMENT

export function importContracts(payload) {
  return dispatch =>
    axios.post(CONTRACT_IMPORT, payload, { headers: { 'content-type': 'multipart/form-data' } }).then(
      res =>
        new Consequence({
          dispatch,
          payload: { data: res },
          eventTypes: { success: NEW_IMPORT_CONTRACTS, error: 'ERROR' }
        })
    );
} // END importContractXls

export function updateContractFrecuency(uuid, id, payload) {
  return dispatch =>
    axios
      .put(parseUrl(CONTRACT_FRECUENCY, { uuid, id }), payload)
      .then(() => axios.get(parseUrl(CONTRACT_DETAIL, { uuid })))
      .then(
        res =>
          new Consequence({
            dispatch,
            payload: { data: get(res, 'data.data', {}) },
            eventTypes: { success: NEW_SINGLE_CONTRACT, error: 'ERROR' }
          })
      );
} // END updateContractFrecuency

export function updateContractDetail(uuid, payload) {
  return dispatch =>
    axios
      .put(parseUrl(CONTRACT_DETAIL, { uuid }), payload)
      .then(() => axios.get(parseUrl(CONTRACT_DETAIL, { uuid })))
      .then(
        res =>
          new Consequence({
            dispatch,
            payload: { data: get(res, 'data.data', {}) },
            eventTypes: { success: NEW_SINGLE_CONTRACT, error: 'ERROR' }
          })
      );
} // END updateContractFrecuency

export function updateSingleContract(uuid, payload) {
  return dispatch =>
    axios
      .put(parseUrl(CONTRACT_UPDATE, { uuid }), payload)
      .then(() => axios.get(parseUrl(CONTRACT_DETAIL, { uuid })))
      .then(
        res =>
          new Consequence({
            dispatch,
            payload: { data: get(res, 'data.data', {}) },
            eventTypes: { success: NEW_SINGLE_CONTRACT, error: 'ERROR' }
          })
      );
}

export function getContractsVisibilityFilters(filters, updateTable = true, searching = true) {
  let initialValuesTags = {
    Estado: {
      active: false,
      inactive: false,
      no_ended: false
    },
    Recurrencia: {
      monthly: false,
      weekly: false
    },
    Domiciliado: {
      1: false,
      2: false
    }
  };
  filters.map(item => {
    if (item.label in initialValuesTags) {
      if (item.value) {
        item.value.split(',').map(value => {
          initialValuesTags[item.label][value] = true;
        });
      }
    }
  });
  return dispatch =>
    Promise.resolve(
      dispatch({ type: NEW_CONTRACTS_FILTERS, payload: { filters, updateTable, searching } }),
      dispatch({
        type: NEW_VALUES_CONTRACTS,
        payload: initialValuesTags
      })
    );
} // END getContractsVisibilityFilters

export function updateLoadingTable(loadingTable) {
  return dispatch =>
    Promise.resolve(
      dispatch({
        type: NEW_LOADING_TABLE,
        payload: loadingTable
      })
    );
} // END updateLoadingTable

export function getContractsV2(allFilters, cancelToken) {
  if (typeof allFilters !== 'object' && !Array.isArray(allFilters)) allFilters = {};
  const { personalized = {}, filters = {} } = allFilters;
  const emptyAllFilters = isEmpty(allFilters);
  const emptyPersonalized = isEmpty(personalized);
  const emptyFilters = isEmpty(filters);
  const qsPersonalizedConfig = { encode: false };
  let url = `${CONTRACT_BASE}`;

  if (!emptyAllFilters) {
    if (!emptyPersonalized) url = url.concat(`?${qsFilters.stringify(personalized, qsPersonalizedConfig)}`);
    if (!emptyFilters) {
      let strFilters = String(encodeURIComponent(qsFilters.stringify(filters))).replace(/&/gi, '%26'); // Library issue
      url = url.concat(`${emptyPersonalized ? '?filters=' : '&filters='}${strFilters}`);
    }
  }

  return dispatch =>
    axios
      .get(url, cancelToken ? { cancelToken: cancelToken.token } : {})
      .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_CONTRACTS, 'ERROR', res))
      .then(res => thunkHandler(dispatch, get(res, 'data.filters_stats', []), NEW_STATS_CONTRACTS, 'ERROR', res))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END getContractsV2

export function newExportContracts(allFilters) {
  if (typeof allFilters !== 'object' && !Array.isArray(allFilters)) allFilters = {};
  const { personalized = {}, filters = {} } = allFilters;
  const emptyAllFilters = isEmpty(allFilters);
  const emptyPersonalized = isEmpty(personalized);
  const emptyFilters = isEmpty(filters);
  const qsPersonalizedConfig = { encode: false };
  let url = `${CONTRACT_EXPORT}`;

  if (!emptyAllFilters) {
    if (!emptyPersonalized) url = url.concat(`?${qsFilters.stringify(personalized, qsPersonalizedConfig)}`);
    if (!emptyFilters) {
      let strFilters = String(encodeURIComponent(qsFilters.stringify(filters))).replace(/&/gi, '%26'); // Library issue
      url = url.concat(`${emptyPersonalized ? '?filters=' : '&filters='}${strFilters}`);
    }
  }

  return dispatch =>
    axios
      .get(url, { responseType: 'arraybuffer' })
      .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_EXPORT_CONTRACTS, 'ERROR', res))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END exportInvoices

export function resetSearching() {
  return dispatch =>
    Promise.resolve(
      dispatch({
        type: NEW_SEARCHING,
        payload: false
      })
    );
} // END updateLoadingTable

export function newStats() {
  return dispatch =>
    Promise.resolve(contracts)
      .then(stats => dispatch({ type: NEW_STATS_CONTRACTS, payload: { filters_stats: stats } }))
      .catch(error => dispatch({ type: 'ERROR', payload: error }));
} // END newStats

export const changeContractSelect = (data, checked) => {
  return (dispatch, getState) => {
    const selected = getState().contracts.selected;
    if (Array.isArray(data)) {
      let newDataArr = [...selected];
      data.forEach(el => {
        const exist = selected.find(item => item.uuid === el.uuid);
        if (!exist && checked) newDataArr.push(el);
        if (exist && !checked) newDataArr = newDataArr.filter(item => item.uuid !== el.uuid);
      });
      dispatch({
        type: CHANGE_CONTRACT_SELECT,
        payload: { data: newDataArr }
      });
    } else {
      let newData = [];
      const exist = selected.find(item => item.uuid === data.uuid);
      if (exist) newData = selected.filter(item => item.uuid !== data.uuid);
      else newData = [...selected, data];
      dispatch({
        type: CHANGE_CONTRACT_SELECT,
        payload: { data: newData }
      });
    }
  };
};

export const clearContractSelect = () => ({
  type: CHANGE_CONTRACT_SELECT,
  payload: { data: [] }
});

export const setContractToEdit = data => ({
  type: SET_CONTRACT_TO_EDIT,
  payload: { data }
});

export function getEarlyPaymentCatalog() {
  return dispatch =>
    axios
      .get(EARLY_PAYMENT)
      .then(res => thunkHandler(dispatch, get(res, 'data'), EARLY_CATALOG, 'ERROR'))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}
export function requestEarlyPayment(payload) {
  return dispatch =>
    axios.post(EARLY_PAYMENT_BASE, payload).then(res => {
      getEarlyPaymentAll()(dispatch);
      new Consequence({
        dispatch,
        payload: { data: res },
        eventTypes: { success: NEW_EARLY_PAYMENT, error: 'ERROR' }
      });
    });
}
export function deleteEarlyPayment(earlyPaymentId) {
  return dispatch =>
    axios
      .delete(parseUrl(EARLY_PAYMENT_BYID, { earlyPaymentId }))
      .then(() => {
        getEarlyPaymentAll()(dispatch);
        dispatch({ type: DELETE_EARLY_PAYMENT, payload: null });
      })
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} //END deleteConektaIntegration

export function getEarlyPaymentContracts(earlyPaymentId) {
  return dispatch =>
    axios
      .get(parseUrl(EARLY_PAYMENT_CONTRACT, { earlyPaymentId }))
      .then(res => thunkHandler(dispatch, get(res, 'data'), EARLY_CONTRACT, 'ERROR'))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

export function getEarlyPaymentAll() {
  return dispatch =>
    axios
      .get(EARLY_PAYMENT_BASE)
      .then(res => thunkHandler(dispatch, get(res, 'data'), EARLY_ALL, 'ERROR'))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}
export function resetEarlyByid() {
  return dispatch =>
    Promise.resolve(
      dispatch({
        type: RESET_EARLY_BYID,
        payload: null
      })
    );
} // END updateLoadingTable

export function getEarlyPaymentByid(earlyPaymentId) {
  return dispatch => {
    resetEarlyByid()(dispatch);
    axios
      .get(parseUrl(EARLY_PAYMENT_BYID, { earlyPaymentId }))
      .then(res => thunkHandler(dispatch, get(res, 'data'), EARLY_BYID, 'ERROR'))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
  };
}
export function updateEarlyPaymentStatus(payload, earlyPaymentId) {
  return dispatch =>
    axios.put(EARLY_PAYMENT_BYID.replace(':earlyPaymentId', earlyPaymentId), payload).then(res => {
      getEarlyPaymentAll()(dispatch);
      resetEarlyByid()(dispatch);
      return new Consequence({
        dispatch,
        payload: { data: get(res, 'data.data') },
        eventTypes: { success: UPDATE_EARLY_PAYMENT, error: 'ERROR' }
      });
    });
}



// WEBPACK FOOTER //
// ./src/redux/actions/contractActions.js